import produce from 'immer';
import { get, each, pull } from 'lodash';
import { getTeachersSurveyObject } from 'selectors';
import * as ActionTypes from '../actions';

const defaultState = { player: null, survey: {}, questionnaires: [] }

const player = (state = defaultState, action) =>
  produce(state, draft => {
    /* eslint-disable default-case */
    switch (action.type) {
      case ActionTypes.PLAYER_RECEIVE:
        draft.player = action.payload;
        return;
      case ActionTypes.PLAYER_SURVEY_RECEIVE:
        draft.survey = action.payload;
        return;
      case ActionTypes.SURVEY_STATUS_RECEIVE: {
        let teacherSurvey = getTeachersSurveyObject(draft.survey);
        if (!teacherSurvey || teacherSurvey.id !== action.payload.result) return;
        draft.survey.entities.surveys[action.payload.result] = action.payload.entities.surveys[action.payload.result];
        each(draft.survey.entities.sections, (v, k) => {
          const section = get(action.payload.entities.sections, k);
          if (section) v.score.teacher = section.score;
        });
        return;
      }
      case ActionTypes.PLAYER_FILTER_RECEIVE:
        if (action.meta.source === 'modal') return state;
        return { ...state, ...action.payload };
      case ActionTypes.WEBNOTE_CREATE_RECEIVE:
        draft.survey.entities.surveys[action.meta.playerQuestionnaireId].notesCount++;
        draft.survey.entities.questions[action.payload.asqQuestionId].notesIds.push(action.payload.id);
        return;
      case ActionTypes.WEBNOTE_DELETE_RECEIVE:
        draft.survey.entities.surveys[action.meta.playerQuestionnaireId].notesCount--;
        pull(draft.survey.entities.questions[action.meta.asqQuestionId].notesIds, action.meta.id);
        return;
    }
  })


export default player;
